import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import ButtonIcon, { shouldRenderButtonIcon } from './button-icon.esm.js';
import isReact from '../../utils/is-react.esm.js';
import { EMPTY_OBJECT } from '../../utils/object.esm.js';
import Flex from '../_primitives/flex/flex.esm.js';
import Text from '../_primitives/text/text.esm.js';

var _excluded = ["sx"];
var ButtonIconMemo = /*#__PURE__*/React.memo(ButtonIcon);
function IconBeforeTextLayout(props) {
  var role = props.role,
    buttonLabel = props.buttonLabel,
    iconBefore = props.iconBefore,
    lhCrop = props.lhCrop,
    textWrap = props.textWrap,
    iconSize = props.iconSize,
    _props$stringNodes = props.stringNodes,
    stringNodes = _props$stringNodes === void 0 ? [] : _props$stringNodes,
    children = props.children,
    _props$textProps = props.textProps,
    textProps = _props$textProps === void 0 ? EMPTY_OBJECT : _props$textProps,
    isLoading = props.isLoading;
  var sx = textProps.sx,
    rest = _objectWithoutProperties(textProps, _excluded);
  var sxStyles = useMemo(function () {
    return _objectSpread2({
      '&.is-hidden': {
        opacity: 0
      }
    }, sx);
  }, [sx]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderButtonIcon(iconBefore) ? /*#__PURE__*/React.createElement(ButtonIconMemo, {
    buttonLabel: buttonLabel,
    icon: iconBefore,
    iconSize: iconSize,
    isLoading: isLoading
  }) : isReact.element(iconBefore) ? /*#__PURE__*/React.createElement(Flex, {
    opacity: isLoading ? 0 : 1
  }, iconBefore) : null, stringNodes.length > 0 ? /*#__PURE__*/React.createElement(Text, _extends({
    className: classNames({
      'is-hidden': isLoading
    }),
    lhCrop: lhCrop,
    ellipsis: !textWrap,
    content: buttonLabel,
    role: role,
    sx: sxStyles
  }, rest), stringNodes) : children);
}

export default IconBeforeTextLayout;
//# sourceMappingURL=icon-before-text-layout.esm.js.map
